import { NbJSThemeOptions, DEFAULT_THEME as baseTheme } from '@nebular/theme';

const baseThemeVariables = baseTheme.variables;

export const DEFAULT_THEME: NbJSThemeOptions = {
	name: 'default',
	base: undefined,
	variables: {
		...baseThemeVariables,
		chartjs: {
			axisLineColor: baseThemeVariables.separator,
			textColor: baseThemeVariables.fgText
		}
	}
};
